import React, { useCallback } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch } from 'functions.js';

// HELPERS
import { useReport } from '../helpers/getReportData';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const FavoritesButton = props => {

  // HOOKS
  const { reportID, fetchReport, report_chart: { chart_id, user_favorite } = {} } = useReport();

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      apiFetch({
        method: 'POST',
        endpoint: ENDPOINTS.dashboard.report.favorite(reportID, chart_id, !user_favorite),
        params: {
          chart_id
        },
        errorMessage: user_favorite ? 'Unable to remove from My Favorites' : 'Unable to add to My Favorites',
        successMessage: user_favorite ? 'Removed from My Favorites' : 'Added to My Favorites',
        onSuccess: () => fetchReport()
      })
    },
    [reportID, fetchReport, chart_id, user_favorite]
  )

  // RENDER
  return (
    <Button
      label={user_favorite ? 'Remove from My Favorites' : 'Add to My Favorites'}
      icon={{
        use: user_favorite ? 'trash' : 'like',
        order: 1
      }}
      onClick={handleClick}
      size="sm"
      outline
      {...props}
    />
  );
};

// EXPORT
export default FavoritesButton;
